import React, { useState } from 'react';
import { Box, Button, Modal, Typography } from '@mui/material';
import { AntSwitch } from '../../components/antSwitch';
import { useNavigate } from 'react-router-dom';
import DeleteModal from './deleteModal';
import StatusModal from './statusModal';
import { tableDeleteButtonSx, tableViewButtonSx } from '../../styles/actionStyles';

const textCellSx = {
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: '#1C1B1F',
};

export default function CropsColumn(props) {
  const navigate = useNavigate();
  const { setAlert, setOpenAlert, setResponseMsg, setLoading, getCropsData } = props;
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const ALERT_DURATION = 2000;

  const alertClose = () => {
    setAlert('');
    setOpenAlert(false);
  };

  const handleOpenDeleteModal = (id, status) => {
    setSelectedId(id);
    setSelectedStatus(status);
    setOpenDeleteModal(true);
  };

  const handleOpenStatusModal = (id, status) => {
    setSelectedId(id);
    setSelectedStatus(status);
    setOpenStatusModal(true);
  };

  const cropsColumn = [
    {
      field: 'name',
      headerName: 'Crop Name',
      flex: 1.2,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => (
        <Typography sx={{ ...textCellSx }}>
          {params.value || '-'}
        </Typography>
      ),
    },
    {
      field: 'category',
      headerName: 'Category',
      flex: 1,
      minWidth: 140,
      sortable: false,
      renderCell: (params) => (
        <Typography sx={{ ...textCellSx }}>
          {params.value ? params.value.replace(/_/g, ' ') : '-'}
        </Typography>
      ),
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 1.5,
      minWidth: 280,
      sortable: false,
      renderCell: (params) => {
        const htmlString = params.value || '';
        const plainText = htmlString.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
        return (
          <Typography sx={{ ...textCellSx, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {plainText || '-'}
          </Typography>
        );
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      minWidth: 190,
      sortable: false,
      renderCell: (params) => {
        const isActive = params.row.status === 'ACTIVE';
        return (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, width: '100%' }}>
              <AntSwitch checked={isActive} onChange={() => handleOpenStatusModal(params.row.id, params.row.status)} inputProps={{ 'aria-label': 'controlled' }} />
              <Typography sx={{ fontSize: 16, lineHeight: '24px', letterSpacing: '0.15px', fontWeight: 500, color: isActive ? '#4F8506' : '#625B71' }}>
                {isActive ? 'Active' : 'Inactive'}
              </Typography>
            </Box>
            <Modal open={openStatusModal} onClose={() => setOpenStatusModal(false)} BackdropProps={{ sx: { backgroundColor: 'rgba(0, 0, 0, 0.1)' } }}>
              <div>
                <StatusModal onClose={() => setOpenStatusModal(false)} getCropsData={getCropsData} selectedId={selectedId} selectedStatus={selectedStatus} alertClose={alertClose} setOpenAlert={setOpenAlert} setResponseMsg={setResponseMsg} setAlert={setAlert} ALERT_DURATION={ALERT_DURATION} setLoading={setLoading} />
              </div>
            </Modal>
          </>
        );
      },
    },
    {
      field: 'actions',
      headerName: 'Action',
      flex: 1.15,
      minWidth: 220,
      sortable: false,
      renderCell: (params) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, width: '100%' }}>
            <Button
              onClick={() => navigate(`/cropsView/${params.row.id}?type=edit`)}
              startIcon={<span className="material-symbols-rounded">visibility</span>}
              sx={tableViewButtonSx}
            >
              View
            </Button>
            <Button
              onClick={() => handleOpenDeleteModal(params.row.id, params.row.status)}
              startIcon={<span className="material-symbols-rounded">delete</span>}
              sx={{ ...tableDeleteButtonSx, minWidth: 96 }}
            >
              Delete
            </Button>
          </Box>
          <Modal open={openDeleteModal} onClose={() => setOpenDeleteModal(false)} BackdropProps={{ sx: { backgroundColor: 'rgba(0, 0, 0, 0.1)' } }}>
            <div>
              <DeleteModal onClose={() => setOpenDeleteModal(false)} getCropsData={getCropsData} selectedId={selectedId} selectedStatus={selectedStatus} alertClose={alertClose} setOpenAlert={setOpenAlert} setResponseMsg={setResponseMsg} setAlert={setAlert} ALERT_DURATION={ALERT_DURATION} setLoading={setLoading} />
            </div>
          </Modal>
        </>
      ),
    },
  ];

  return cropsColumn;
}
